import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    ref={ref}
    {...props}
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3641 3.05037C14.7546 2.65984 14.7546 2.02668 14.3641 1.63615C13.9736 1.24563 13.3404 1.24563 12.9499 1.63615L8.00011 6.58591L3.05037 1.63617C2.65985 1.24564 2.02668 1.24564 1.63616 1.63617C1.24563 2.02669 1.24563 2.65986 1.63616 3.05038L6.5859 8.00012L1.63615 12.9499C1.24563 13.3404 1.24563 13.9736 1.63615 14.3641C2.02668 14.7546 2.65984 14.7546 3.05037 14.3641L8.00011 9.41434L12.9499 14.3641C13.3404 14.7546 13.9736 14.7546 14.3641 14.3641C14.7546 13.9736 14.7546 13.3404 14.3641 12.9499L9.41432 8.00012L14.3641 3.05037Z"
        fill="currentColor"
      />
    </g>
  </svg>
));
